import { Component } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { USER_FORM_NAME } from 'src/app/services/form/form.factory';
import { FormService } from 'src/app/services/form/form.service';

@Component({
  selector: 'app-user-email-form',
  templateUrl: './user-email-form.component.html',
  styleUrls: ['./user-email-form.component.scss']
})
export class UserEmailFormComponent {
  get form(): FormGroup { return this.formService.form.get(USER_FORM_NAME) as FormGroup; }

  get userEmail(): FormControl { return this.form.get('email') as FormControl; }
  get terms_of_service(): FormControl { return this.form.get('terms_of_service') as FormControl; }
  get password(): FormControl { return this.form.get('password') as FormControl; }

  showLoginForm = false;
  loginLoading = false;

  constructor(
    private formService: FormService,
  ) { }

  onShowLoginForm() {
    this.showLoginForm = true;

    this.updateWholeForm();
    this.password.enable();
    this.terms_of_service.disable();
  }

  onShowRegisterForm() {
    this.showLoginForm = false;

    this.updateWholeForm();
    this.password.disable();
    this.terms_of_service.enable();
  }

  private updateWholeForm(form: AbstractControl = this.formService.form, maxDepth = 32): void {
    if (maxDepth <= 0) {
      return;
    }

    if (form instanceof FormControl) {
      form.updateValueAndValidity();
    } else if (form instanceof FormGroup) {
      form.updateValueAndValidity();
      for (const control of Object.values(form.controls)) {
        this.updateWholeForm(control, maxDepth - 1);
      }
    } else if (form instanceof FormArray) {
      form.updateValueAndValidity();
      for (const control of form.controls) {
        this.updateWholeForm(control, maxDepth - 1);
      }
    }
  }
}
